import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const SkeletonizedDashboardText: React.FC<{
  icon: React.ReactNode;
  content?: string | React.ReactNode | null;
  hideIfNoContent?: boolean;
  tooltipText?: string;
}> = ({ icon, content, hideIfNoContent, tooltipText }) => {
  if (!content && hideIfNoContent) {
    return null;
  }

  return (
    <Tooltip title={content != null ? tooltipText : ""}>
      <Box display="flex" alignItems="center" gap={1} sx={{ height: "100%", py: 1 }}>
        <Box sx={{ width: "25px", height: "25px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {content == null ? <Skeleton variant="circular" width={20} height={20} /> : icon}
        </Box>
        {content == null ? (
          <Skeleton variant="text" width="70%" sx={{ minWidth: "100px" }} />
        ) : (
          <Typography variant="body1">{content}</Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default SkeletonizedDashboardText;
